import { ErrorView } from "@/components/ui/layout/error/errorView"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { PromoCodeFormView, type PromoCodeFormViewRef } from "@modules/promoCode/components/promoCodeFormView"
import { PromoCodeInfoResume } from "@modules/promoCode/components/promoCodeInfoResume"
import { PromoCodeListView } from "@modules/promoCode/components/promoCodeListView"
import { BoxPromoCodeEntity } from "@modules/promoCode/entities/boxPromoCodeEntity"
import { PromoCodeEntity } from "@modules/promoCode/entities/promoCodeEntity"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { Suspense, useRef } from "react"
import { ErrorBoundary } from "react-error-boundary"

export const usePromoCodeSidebar = () => {
  const { sidebarNavigateTo } = useSidebar()
  const promoCodeFormViewRef = useRef<PromoCodeFormViewRef>(null)

  const navigateToPromoCodeListView = () => {
    sidebarNavigateTo({
      content: <PromoCodeListView />,
      replaceAllComponents: true,
    })
  }

  const navigateToPromoCodeDetailsView = (
    promoCode: PromoCodeEntity | BoxPromoCodeEntity,
    replaceLastComponent: boolean = false,
  ) => {
    sidebarNavigateTo({
      content: <PromoCodeInfoResume promoCode={promoCode} />,
      replaceLastComponent,
    })
  }

  const navigateToPromoCodeFormView = (promoCode?: PromoCodeEntity | BoxPromoCodeEntity) => {
    sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <PromoCodeFormView ref={promoCodeFormViewRef} updatedPromoCode={promoCode} />
          </Suspense>
        </ErrorBoundary>
      ),
      onHide: () => {
        return promoCodeFormViewRef.current ? promoCodeFormViewRef.current.onClose() : Promise.resolve(true)
      },
    })
  }

  return {
    navigateToPromoCodeListView,
    navigateToPromoCodeDetailsView,
    navigateToPromoCodeFormView,
  }
}
